<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">
        <a class="logo" href="#home" @click="closeMenu">
          <img :src="company.logo" :alt="company.brand" />
          <span class="logo__name">{{ company.brand }}</span>
        </a>
        <nav class="nav">
          <a href="#home">{{ t("nav.home") }}</a>
          <div class="nav__item" :class="{ 'is-open': megaOpen }">
            <button class="nav-link" type="button" @click="megaOpen = !megaOpen">
              {{ t("nav.services") }} ▾
            </button>
            <div class="mega">
              <a
                v-for="(id, index) in serviceIds"
                :key="id"
                href="#hizmetler"
                @click="closeMenu"
              >
                <span class="ico">{{ String(index + 1).padStart(2, "0") }}</span>
                {{ t(`services.items.${id}.title`) }}
              </a>
            </div>
          </div>
          <a href="#paketler">{{ t("nav.packages") }}</a>
          <a href="#hakkimizda">{{ t("nav.about") }}</a>
          <a href="#iletisim">{{ t("nav.contact") }}</a>
        </nav>
        <div class="header__actions">
          <div class="lang" :class="{ 'is-open': langOpen }">
            <button
              class="lang__btn"
              type="button"
              :aria-expanded="langOpen"
              @click="langOpen = !langOpen"
            >
              {{ localeLabel }} ▾
            </button>
            <div class="lang__menu">
              <button
                v-for="item in locales"
                :key="item.id"
                type="button"
                :class="{ 'is-active': locale === item.id }"
                @click="chooseLocale(item.id)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>
          <a
            class="btn btn--primary btn--sm header-cta"
            :href="quoteHref"
            target="_blank"
            rel="noopener"
          >
            <span>{{ t("nav.quote") }}</span>
            <span class="header-cta__arrow" aria-hidden="true">→</span>
          </a>
          <button
            class="menu-toggle"
            type="button"
            :class="{ 'is-active': menuOpen }"
            :aria-label="menuOpen ? t('nav.closeMenu') : t('nav.openMenu')"
            @click="menuOpen = !menuOpen"
          >
            <span class="menu-toggle__bar"></span>
            <span class="menu-toggle__bar"></span>
            <span class="menu-toggle__bar"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- MOBİL AÇILIR MENÜ (DROPDOWN) -->
    <transition name="menu-dropdown">
      <div v-if="menuOpen" class="mobile-dropdown" role="dialog" aria-modal="true">
        <nav class="mobile-dropdown__nav">
          <a class="mobile-dropdown__link" href="#home" @click="closeMenu">
            {{ t("nav.home") }}
          </a>
          <a class="mobile-dropdown__link" href="#hizmetler" @click="closeMenu">
            {{ t("nav.services") }}
          </a>
          <a class="mobile-dropdown__link" href="#paketler" @click="closeMenu">
            {{ t("nav.packages") }}
          </a>
          <a class="mobile-dropdown__link" href="#hakkimizda" @click="closeMenu">
            {{ t("nav.about") }}
          </a>
          <a class="mobile-dropdown__link" href="#iletisim" @click="closeMenu">
            {{ t("nav.contact") }}
          </a>
        </nav>

        <div class="mobile-dropdown__footer">
          <a
            class="btn btn--primary btn--block mobile-dropdown__cta"
            :href="quoteHref"
            target="_blank"
            rel="noopener"
            @click="closeMenu"
          >
            <span>{{ t("nav.quote") }}</span>
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </transition>

    <!-- Menü açıkken arkadaki karartma perdesi -->
    <transition name="menu-backdrop">
      <div v-if="menuOpen" class="mobile-backdrop" @click="closeMenu"></div>
    </transition>
  </header>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { company, whatsappHref } from "@/data/company";
import { serviceIds } from "@/data/packages";
import { setLocale } from "@/i18n";

export default {
  name: "SiteHeader",
  setup() {
    const { t, locale } = useI18n();
    const langOpen = ref(false);
    const menuOpen = ref(false);
    const megaOpen = ref(false);
    const locales = [
      { id: "tr", label: "Türkçe" },
      { id: "en", label: "English" },
      { id: "de", label: "Deutsch" },
    ];
    const localeLabel = computed(() => {
      const found = locales.find((item) => item.id === locale.value);
      return found ? found.id.toUpperCase() : "TR";
    });
    const quoteHref = computed(() => whatsappHref(t("contact.waPrefill")));

    function chooseLocale(id) {
      setLocale(id);
      langOpen.value = false;
    }

    function closeMenu() {
      menuOpen.value = false;
      megaOpen.value = false;
    }

    function handleOutsideClick(event) {
      if (langOpen.value && !event.target.closest(".lang")) {
        langOpen.value = false;
      }
      if (megaOpen.value && !event.target.closest(".nav__item")) {
        megaOpen.value = false;
      }
      if (menuOpen.value && !event.target.closest(".menu-toggle") && !event.target.closest(".mobile-dropdown")) {
        menuOpen.value = false;
      }
    }

    function handleResize() {
      if (window.innerWidth > 980 && menuOpen.value) {
        menuOpen.value = false;
      }
    }

    onMounted(() => {
      if (typeof window !== "undefined") {
        window.addEventListener("click", handleOutsideClick);
        window.addEventListener("resize", handleResize);
      }
    });

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("click", handleOutsideClick);
        window.removeEventListener("resize", handleResize);
      }
    });

    return {
      t,
      locale,
      company,
      langOpen,
      menuOpen,
      megaOpen,
      locales,
      localeLabel,
      quoteHref,
      serviceIds,
      chooseLocale,
      closeMenu,
    };
  },
};
</script>
